"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ErrorField = _interopRequireDefault(require("./ErrorField"));

var _LiveSaver = _interopRequireDefault(require("./LiveSaver"));

var _excluded = ["label", "input", "meta", "liveSaver"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CheckBoxToggle = function CheckBoxToggle(props) {
  var label = props.label,
      input = props.input,
      meta = props.meta,
      liveSaver = props.liveSaver,
      rest = _objectWithoutProperties(props, _excluded);

  var id = props.id || "checkbox_".concat(input ? input.name : props.name);

  var toogle = /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-element"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container-checkbox-toggle"
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    id: id,
    checked: Boolean(input ? input.value : props.value)
  }, input, rest, {
    type: "checkbox"
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: "checkbox-toggle",
    htmlFor: id
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "checkbox-toggle-slider round"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkbox-toggle-title"
  }, label)), /*#__PURE__*/_react["default"].createElement(_ErrorField["default"], {
    meta: meta
  }));

  return liveSaver ? /*#__PURE__*/_react["default"].createElement(_LiveSaver["default"], {
    liveSaver: liveSaver
  }, toogle) : toogle;
};

CheckBoxToggle.displayName = 'CheckBoxToggle';
CheckBoxToggle.propTypes = {
  label: _propTypes["default"].string
};
CheckBoxToggle.defaultProps = {
  label: ''
};
var _default = CheckBoxToggle;
exports["default"] = _default;